import { render, staticRenderFns } from "./MemberChangeMajorMedicalModal.vue?vue&type=template&id=3bb31daa&"
import script from "./MemberChangeMajorMedicalModal.vue?vue&type=script&lang=js&"
export * from "./MemberChangeMajorMedicalModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberChangeMajorMedicalModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports